import { Bounds, ImageOverlay, Proj } from "leaflet"
import type { LatLngBounds, Map as LeafletMap } from "leaflet"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useMap } from "react-leaflet"

export interface ICustomImageOverlayProps {
  url: string
  bounds: LatLngBounds
  crs?: Proj.CRS
}

export function CustomImageOverlay(props: ICustomImageOverlayProps): ReactElement {
  const { url, bounds, crs } = props
  const map: LeafletMap = useMap()

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    const imageOverlay: ImageOverlay = crs ? createCrsImageLayer() : createImageLayer()

    return () => {
      if (imageOverlay && map) {
        map.removeLayer(imageOverlay)
      }
    }
  }, [])

  function createCrsImageLayer(): ImageOverlay {
    const projectedBounds: Bounds = new Bounds(crs!.project(bounds.getSouthEast()), crs!.project(bounds.getNorthWest()))
    const imageOverlay = new Proj.ImageOverlay(url, projectedBounds as unknown as LatLngBounds, {
      className: "image-overlay"
    }).addTo(map)

    return imageOverlay
  }

  function createImageLayer(): Proj.ImageOverlay {
    const imageOverlay = new ImageOverlay(url, bounds, {
      className: "image-overlay"
    }).addTo(map)

    return imageOverlay
  }

  return <></>
}
